import { Order, PartnerConfig } from '@/types';

import { COBRANDED_PARTNERS } from '../configs/cobrandedPartners';

const getCobrandedConfig = (order: Order): PartnerConfig | undefined => {
  return order?.channel && order.channel in COBRANDED_PARTNERS
    ? COBRANDED_PARTNERS[order.channel]
    : undefined;
};

export default getCobrandedConfig;
